import React, { useContext } from 'react';
import { InfoBanner } from 'app/shared/info-banner';
import { UpsellContext } from 'contexts/upsell';
import styles from './banner.module.css';

const getCopy = (upsell) => {
  if (!upsell) return null;

  if (upsell.to === 'professional') {
    return 'Ready to send more and know what’s working? Get 10x more email capacity and detailed reports.';
  }

  return (
    <>
      <p>
        <b>Turn more customer moments into automated journeys.</b>
      </p>
      <p>
        The Enterprise plan gives you 15x emails and advanced automation for more sophisticated
        engagement.
      </p>
    </>
  );
};

export const UpsellBanner = () => {
  const { upsell, loading } = useContext(UpsellContext);
  const copy = getCopy(upsell);

  if (loading || !copy) return null;

  const message = <div className={styles.inner}>{copy}</div>;

  return <InfoBanner message={message} type="info" show_icon={false} />;
};
